module.exports = __webpack_public_path__ + "img/15_95.7fc5ed45.png";